document.addEventListener('change', function (event) {
  var select = event.target.closest('[data-re-conditional-select]');
  if (!select) return;
  var panel = select.parentElement.querySelector('[data-re-conditional-panel="' + select.dataset.reConditionalSelect + '"]');
  if (!panel) return;
  var show = !/^(No second side|None)$/.test(select.value);
  panel.hidden = !show;
  panel.querySelectorAll('textarea,input,select').forEach(function (field) { field.required = show; });
});

document.addEventListener('DOMContentLoaded', function () {
  var today = new Date();
  var localToday = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  var defaultDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  var businessDaysAdded = 0;
  while (businessDaysAdded < 5) {
    defaultDate.setDate(defaultDate.getDate() + 1);
    if (defaultDate.getDay() !== 0 && defaultDate.getDay() !== 6) businessDaysAdded += 1;
  }
  var localDefaultDate = new Date(defaultDate.getTime() - defaultDate.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  document.querySelectorAll('[data-re-event-date-input]').forEach(function (input) {
    input.min = localToday;
    if (!input.value) input.value = localDefaultDate;
  });
});
